<template>
         <div class="widget widget--border-box twitter-feed">
                            <div class="widget__title has-ajax-load">
                                <h4>Oznake</h4>
                            </div>
                            <div class="twitter-box">
                                <div class="m-post-content">
                               <div v-if="tags && tags.length > 0" class="post-tags">
                                <div class="tags-wrap">
                                    <router-link v-for="tag in tags" :key="'tag_'+tag.tagID" class="cat-world" :to="{ name:'category', query: { tagId: tag.tagID }}"><i class="fa fa-tag" aria-hidden="true"></i>{{ tag.name }}</router-link>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
</template>

<script>
    import { TagsService } from '../common/api.service'

    export default {
        name: "TagsBox",
        data() {
            return {
                tags: []
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                TagsService.getActiveTagsSideBar()
                            .then(res => 
                            { 
                                this.tags = res.data;
                            });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TagsBox.vue